{
  "appName": "Bookclub",
  "tagline": "Read together, whatever edition you hold.",
  "common": {
    "or": "or",
    "continue": "Continue",
    "backToSignIn": "Back to sign in",
    "email": "Email",
    "password": "Password",
    "show": "Show",
    "hide": "Hide",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "back": "Back",
    "save": "Save",
    "saved": "Saved.",
    "cancel": "Cancel",
    "delete": "Delete",
    "close": "Close"
  },
  "home": {
    "greeting": "Hi, {{name}}",
    "signOut": "Sign out",
    "account": "Account",
    "findBook": "Find a book",
    "yourClubs": "Your clubs",
    "noClubs": "No clubs yet. Start one and invite your friends, or join with an invite link or code.",
    "createClub": "Start a club",
    "joinClub": "Join with a code",
    "members_one": "{{count}} member",
    "members_other": "{{count}} members",
    "noBookYet": "No book chosen yet",
    "nextMeeting": "Next meeting {{when}}",
    "readingNow": "Reading now",
    "notReading": "You're not reading anything right now.",
    "startBook": "Start a book",
    "shelf": "Your shelf",
    "alsoReading": "Also reading",
    "startAnother": "Start another book",
    "openReading": "Notes, history and your copy"
  },
  "auth": {
    "google": "Continue with Google",
    "signIn": {
      "title": "Sign in",
      "subtitle": "Welcome back.",
      "submit": "Sign in",
      "forgot": "Forgot your password?",
      "noAccount": "New here?",
      "createAccount": "Create an account",
      "accountDeleted": "Your account was deleted. Thank you for reading with us."
    },
    "signUp": {
      "title": "Create your account",
      "subtitle": "Join a club, log your page, leave notes for the others.",
      "name": "Your name",
      "nameHint": "Shown to the people in your clubs.",
      "passwordHint": "At least {{min}} characters.",
      "submit": "Create account",
      "haveAccount": "Already have an account?",
      "signIn": "Sign in",
      "agree": "By creating an account you accept the terms of use and the privacy policy, linked below."
    },
    "forgot": {
      "title": "Forgot your password?",
      "subtitle": "Enter your email and we'll send you a link to choose a new one.",
      "submit": "Send reset link"
    },
    "checkEmail": {
      "title": "Check your email",
      "signup": "We sent a confirmation link to {{email}}. Open it to finish creating your account.",
      "unverified": "Confirm your email first. We sent a new link to {{email}}.",
      "reset": "If there's an account for {{email}}, we sent it a link to choose a new password. The link works for 1 hour.",
      "spam": "Nothing after a few minutes? Check your spam folder.",
      "resend": "Send the link again",
      "resendIn": "Send again in {{seconds}} s",
      "resent": "Sent. Check your inbox."
    },
    "reset": {
      "title": "Choose a new password",
      "newPassword": "New password",
      "submit": "Save new password",
      "doneTitle": "Password changed",
      "doneBody": "You've been signed out everywhere. Sign in with your new password.",
      "invalidTitle": "This link doesn't work anymore",
      "invalidBody": "Reset links work once, for 1 hour. Ask for a new one.",
      "askAgain": "Send a new link"
    },
    "confirmed": {
      "title": "Email confirmed",
      "body": "Welcome to Bookclub.",
      "invalidTitle": "This link doesn't work anymore",
      "invalidBody": "Confirmation links work once, for 24 hours. Sign in and we'll send you a new one."
    },
    "validation": {
      "nameRequired": "Enter your name.",
      "emailInvalid": "Enter a valid email address.",
      "passwordTooShort": "Use at least {{min}} characters."
    },
    "errors": {
      "invalidCredentials": "Wrong email or password.",
      "passwordTooShort": "Use at least {{min}} characters.",
      "passwordTooLong": "That password is too long.",
      "passwordCompromised": "This password has appeared in a known data breach. Choose a different one.",
      "invalidEmail": "Enter a valid email address.",
      "tooManyAttempts": "Too many attempts. Wait a minute and try again.",
      "network": "Can't reach the server. Check your connection and try again.",
      "googleCancelled": "Google sign-in was cancelled.",
      "googleNotLinked": "This email already has a Bookclub account that isn't confirmed yet. Confirm it with the link we emailed, then Google sign-in will work too.",
      "googleFailed": "Google sign-in didn't work. Try again, or use your email and password.",
      "generic": "Something went wrong. Try again.",
      "invalidPassword": "Your current password is wrong.",
      "googleEmailMismatch": "That Google account uses a different email address. You can only connect a Google account with the same address as your Bookclub account.",
      "googleTaken": "That Google account is already connected to another Bookclub account."
    },
    "appleFailed": "Sign in with Apple didn’t work. Try again, or use your email."
  },
  "server": {
    "checking": "Checking the server…",
    "connected": "Server connected · {{env}} · version {{version}}",
    "degraded": "Server reachable, but its database is not answering",
    "unreachable": "Can't reach the server",
    "retry": "Try again"
  },
  "notFound": {
    "title": "Page not found",
    "back": "Go to the start"
  },
  "account": {
    "title": "Account",
    "profile": "Profile",
    "name": "Your name",
    "nameHint": "Shown to the people in your clubs.",
    "email": "Email",
    "emailNote": "Your sign-in address. It's never shown to other members.",
    "methods": "Ways to sign in",
    "password": "Password",
    "passwordSet": "Set",
    "passwordNotSet": "Not set: you sign in with Google.",
    "changePassword": "Change password",
    "addPassword": "Add a password",
    "addPasswordSent": "We sent a link to {{email}}. Open it to choose a password.",
    "google": "Google",
    "googleConnected": "Connected",
    "googleNotConnected": "Not connected",
    "connectGoogle": "Connect Google",
    "disconnectGoogle": "Disconnect",
    "disconnectNeedsPassword": "Add a password before disconnecting Google, so you can still sign in.",
    "googleDisconnected": "Google disconnected. Sign in with your password from now on.",
    "devices": "Devices",
    "devicesCount_one": "You're signed in on this device only.",
    "devicesCount_other": "You're signed in on {{count}} devices, including this one.",
    "signOutOthers": "Sign out on all other devices",
    "othersSignedOut": "Signed out everywhere else.",
    "blockedTitle": "Blocked people",
    "blockedBody": "You and the people you block don't see each other's notes or replies.",
    "blockedNone": "You haven't blocked anyone.",
    "unblock": "Unblock",
    "unblockLabel": "Unblock {{name}}",
    "unblocked": "Unblocked {{name}}.",
    "data": "Your data",
    "dataBody": "Download everything Bookclub stores about you, as a JSON file.",
    "download": "Download my data",
    "exportLimited": "You have downloaded your data several times in the last hour. Try again later.",
    "dangerTitle": "Delete account",
    "dangerBody": "Permanently delete your account and everything in it.",
    "deleteLink": "Delete my account…",
    "signOut": "Sign out"
  },
  "changePassword": {
    "title": "Change password",
    "current": "Current password",
    "new": "New password",
    "submit": "Change password",
    "done": "Password changed. Your other devices were signed out."
  },
  "deleteAccount": {
    "title": "Delete your account?",
    "body": "This permanently deletes your profile, your sign-in methods and everything else stored with your account. It cannot be undone. Download your data first if you want to keep a copy.",
    "passwordLabel": "Enter your password to confirm",
    "googleNote": "You sign in with Google, so no password is needed.",
    "submit": "Delete my account permanently",
    "cancel": "Keep my account",
    "reauthTitle": "Sign in again first",
    "reauthBody": "For your security, deleting an account without a password needs a sign-in from the last 24 hours. Sign out, sign in with Google again, then come back here.",
    "reauthAction": "Sign out now"
  },
  "books": {
    "title": "Find a book",
    "searchLabel": "Title, author or ISBN",
    "searchHint": "The ISBN is on the back cover, above the barcode.",
    "searching": "Searching…",
    "noResults": "No books found for \"{{query}}\".",
    "isbnNotFound": "No book found with ISBN {{isbn}}.",
    "isbnInvalid": "That ISBN isn't valid. Check the digits.",
    "providerDown": "The book catalogue isn't answering right now. Try again in a minute.",
    "rateLimited": "Slow down a little, then try again.",
    "editions_one": "{{count}} edition",
    "editions_other": "{{count}} editions",
    "firstPublished": "First published {{year}}",
    "addManually": "Add a book by hand",
    "cantFind": "Can't find it?",
    "workTitle": "Editions",
    "chooseEdition": "Which edition do you have? Different editions have different page numbers.",
    "filterLabel": "Filter by publisher, year, language or ISBN",
    "noEditions": "No editions match.",
    "notListed": "Don't see yours? Search for its ISBN instead, or add it by hand.",
    "searchIsbn": "Search by ISBN",
    "pages_one": "{{count}} page",
    "pages_other": "{{count}} pages",
    "pagesUnknown": "Page count unknown",
    "edition": {
      "by": "by {{authors}}",
      "publisher": "Publisher",
      "published": "Published",
      "pages": "Pages",
      "isbn": "ISBN",
      "language": "Language",
      "source_openlibrary": "Book data from Open Library.",
      "source_google": "Book data from Google Books.",
      "source_manual": "Added by hand by a reader.",
      "otherEditions": "Other editions of this book",
      "clubsNote": "Pick this edition for a club from the club page: \"Choose the book\" opens this search in picking mode.",
      "details": "This edition"
    },
    "manual": {
      "title": "Add a book by hand",
      "subtitle": "For books the catalogues don't know. Other readers can find it by its ISBN afterwards.",
      "bookTitle": "Title",
      "authors": "Author(s)",
      "authorsHint": "Separate several authors with commas.",
      "pageCount": "Number of pages",
      "pageCountHint": "The last numbered page of the story.",
      "publisher": "Publisher (optional)",
      "year": "Year (optional)",
      "isbn": "ISBN (optional)",
      "submit": "Add book",
      "required": "Required.",
      "pagesInvalid": "Enter a whole number of pages."
    },
    "pickingFor": "Choosing the book for {{club}}.",
    "pickingForReading": "Tap a book to start reading it.",
    "book": {
      "start": "Start reading",
      "openYours": "Open your book",
      "chooseFor": "Choose for {{club}}",
      "usingEdition": "We'll use the {{edition}} edition ({{pages}} pages). You can change it later.",
      "pagesAsked": "We'll ask how many pages your copy has.",
      "differentEdition": "Different edition?",
      "hideEditions": "Hide editions",
      "want": "Want to read",
      "wanted": "In your Want to read",
      "unwant": "Remove",
      "unwantLabel": "Remove from Want to read"
    },
    "scan": "Scan a barcode",
    "fromWant": "From your Want to read",
    "status": {
      "reading": "You’re reading this",
      "finished": "You’ve read this",
      "want": "On your Want to read"
    }
  },
  "clubs": {
    "errors": {
      "not_found": "This club doesn't exist, or you're not a member.",
      "forbidden": "Only the club's owner or admins can do that.",
      "club_full": "This club is full.",
      "owner_cannot_leave": "Hand the club to someone else before you leave.",
      "too_many_clubs": "You already own 20 clubs, which is the limit.",
      "edition_without_pages": "This edition has no page count. Pick another edition, or add yours by hand with its page count.",
      "page_out_of_range": "That page isn't in the club's edition.",
      "finish_before_start": "The finish date is before the start date.",
      "no_current_book": "Choose a book first.",
      "rate_limited": "Too many attempts. Wait a few minutes and try again."
    },
    "create": {
      "title": "Start a club",
      "subtitle": "You'll be the owner. Invite people afterwards with a link.",
      "name": "Club name",
      "description": "Description (optional)",
      "descriptionHint": "What you read, when you meet: anything new members should know.",
      "submit": "Start club"
    },
    "join": {
      "title": "Join a club",
      "subtitle": "Paste the invite link, or type the code someone gave you.",
      "code": "Invite link or code",
      "invalid": "That doesn't look like an invite code. Codes have 8 letters and digits, like ABCD-EFGH.",
      "submit": "Continue"
    },
    "invite": {
      "title": "You're invited",
      "reading": "Reading {{title}}",
      "join": "Join {{name}}",
      "open": "Open club",
      "alreadyMember": "You're already a member.",
      "full": "This club is full, so it can't take new members right now.",
      "invalid": "This invite link doesn't work. It may have been replaced by a newer one: ask for a fresh link.",
      "signInFirst": "Sign in or create an account to join. We will bring you back here.",
      "sheetBody": "Send this link to friends you'd like to read with. It opens the club and lets them join.",
      "orCode": "Or tell them the code"
    },
    "club": {
      "currentBook": "Reading now",
      "noBook": "No book chosen yet.",
      "chooseBook": "Choose the book",
      "changeBook": "Change book or edition",
      "changeDates": "Change dates",
      "started": "Started {{date}}",
      "finishBy": "Finish by {{date}}",
      "finish": "Mark as finished",
      "finishQuestion": "Mark this book as finished? It moves to past books, and you can choose the next one.",
      "finishConfirm": "Yes, finished",
      "meetings": "Meetings",
      "noMeetings": "No meetings planned.",
      "planMeeting": "Plan a meeting",
      "readTo": "Read to page {{page}}",
      "past": "Past",
      "invite": "Invite friends",
      "inviteBody": "Anyone with this link can join while there is room ({{count}} of {{cap}} places taken).",
      "copyLink": "Copy invite link",
      "copied": "Copied",
      "code": "Code: {{code}}",
      "newLink": "Make a new link",
      "newLinkQuestion": "Make a new invite link? The old link and code stop working.",
      "newLinkConfirm": "Yes, new link",
      "members": "Members",
      "pastBooks": "Past books",
      "finishedOn": "Finished {{date}}",
      "settings": "Club settings",
      "you": "you",
      "aboutClub": "About the club",
      "nextMeetingIs": "Next meeting {{when}}",
      "manage": "Manage",
      "membersCount_one": "{{count}} member",
      "membersCount_other": "{{count}} members",
      "sections": "Club sections",
      "tabNotes": "Notes",
      "paceToday": "On pace today: p. {{page}}",
      "youAre": "You: {{where}}",
      "yourBook": "Your book",
      "startBook": "Start reading the book",
      "nextMeetingLabel": "Next meeting",
      "noBookAdmin": "Choose the book the club will read first.",
      "openBook": "Open the book",
      "whoIsWhere": "Who’s where",
      "readToday_one": "Read 1 page today",
      "readToday_other": "Read {{count}} pages today"
    },
    "roles": {
      "owner": "Owner",
      "admin": "Admin",
      "member": "Member"
    },
    "book": {
      "title": "Book dates",
      "start": "Started on",
      "finish": "Finish by (optional)",
      "finishHint": "The pace line in the reading chart aims for this date.",
      "clearFinish": "No finish date",
      "save": "Save dates",
      "chooseFor": "Choose for {{club}}",
      "chosen": "This is the club book now."
    },
    "meeting": {
      "newTitle": "Plan a meeting",
      "editTitle": "Edit meeting",
      "date": "Date",
      "time": "Time",
      "name": "Title",
      "namePlaceholder": "First meeting",
      "location": "Place or video link (optional)",
      "readTo": "Read up to page (optional)",
      "readToHint": "In the club edition, {{edition}}, which has {{pages}} pages.",
      "save": "Save meeting",
      "delete": "Delete meeting",
      "deleteQuestion": "Delete this meeting?",
      "invalidDateTime": "Choose a date and a time.",
      "pageInvalid": "Enter a page between 1 and {{max}}.",
      "titleRequired": "Give the meeting a title.",
      "editShort": "Edit",
      "editLabel": "Edit meeting: {{title}}"
    },
    "member": {
      "joined": "Joined {{date}}",
      "makeAdmin": "Make admin",
      "removeAdmin": "Remove admin role",
      "adminHint": "Admins can edit the club, choose the book, plan meetings and remove members.",
      "makeOwner": "Make owner",
      "makeOwnerQuestion": "Make {{name}} the owner? You become an admin, and only the new owner can undo this.",
      "makeOwnerConfirm": "Yes, make owner",
      "remove": "Remove from club",
      "removeQuestion": "Remove {{name}} from the club? They can rejoin with the invite link unless you make a new one.",
      "removeConfirm": "Yes, remove",
      "noActions": "Nothing to change here."
    },
    "settings": {
      "title": "Club settings",
      "details": "Club",
      "save": "Save",
      "leave": "Leave club",
      "leaveQuestion": "Leave {{name}}? You can rejoin with an invite link.",
      "leaveConfirm": "Yes, leave",
      "ownerLeaveHint": "As the owner, hand the club to another member (on their member page) before you leave.",
      "delete": "Delete club",
      "deleteQuestion": "Delete {{name}} for everyone? Its books, meetings and member list are removed. This cannot be undone.",
      "deleteConfirm": "Yes, delete the club",
      "book": "This book"
    },
    "progress": {
      "title": "Where everyone is",
      "pace": "Pace today: {{percent}}% of the book (p. {{page}} in the club’s copy)",
      "noPace": "Set a finish date or meeting pages to see the pace.",
      "you": "you",
      "overTime": "Over time",
      "overTimeLabel": "Chart of reading progress over time for {{count}} members, with the pace line.",
      "paceLegend": "Pace",
      "youLegend": "You",
      "othersLegend": "Others",
      "myReading": "Your reading",
      "notStarted": "You haven't started the club book yet.",
      "startSame": "I have the club edition",
      "startOther": "I have another edition",
      "openReading": "Log progress",
      "paceStart": "Pace today: just starting. The line climbs toward the next meeting or the finish date."
    },
    "tab": {
      "empty": "You're not in a club yet. Start one and invite friends, or join one with an invite code."
    },
    "setup": {
      "title": "Set up your club",
      "progress": "Step {{step}} of {{count}}",
      "bookTitle": "Which book first?",
      "bookBody": "Everyone reads their own copy; the pages line up by themselves.",
      "findBook": "Find the book",
      "skip": "Skip for now",
      "finishTitle": "When should everyone finish?",
      "finishBody": "{{title}}. A date sets the club’s pace; you can change it later.",
      "finishHint": "Meetings can be planned from the club page.",
      "next": "Next",
      "inviteTitle": "Invite people to {{club}}",
      "done": "Go to the club"
    }
  },
  "reading": {
    "progressLine": "Page {{page}} of {{end}} · {{percent}}%",
    "progressPercent": "{{percent}}%",
    "notStarted": "Not started",
    "finished": "Finished",
    "stopped": "Stopped",
    "startTitle": "Start reading",
    "startSubtitle": "Tell us which pages the story runs over in your copy. Progress and notes line up with other editions through these pages.",
    "firstPage": "Story starts on page",
    "firstPageHint": "Usually 1. Higher if your copy has a long introduction you are skipping.",
    "lastPage": "Story ends on page",
    "lastPageHint": "The last page of the story itself, before notes or appendices.",
    "rangeInvalid": "The last page must come after the first.",
    "start": "Start reading",
    "startThis": "I'm reading this edition",
    "alreadyReading": "You are already reading this book.",
    "openIt": "Open it",
    "log": "Where are you?",
    "page": "Page",
    "percent": "Percent",
    "logPage": "Page you have read up to",
    "logPercent": "Percent read (from your e-reader)",
    "save": "Save",
    "saved": "Saved.",
    "pageInvalid": "Enter a page up to {{max}}.",
    "percentInvalid": "Enter a number from 0 to 100.",
    "finishIt": "I finished it",
    "finishQuestion": "Mark the book as finished?",
    "finishConfirm": "Yes, finished",
    "stop": "Stop reading",
    "stopQuestion": "Stop reading this book? It stays on your shelf with your progress, and you can pick it up again.",
    "stopConfirm": "Yes, stop",
    "resume": "Read again",
    "history": "History",
    "noHistory": "Nothing logged yet.",
    "pages": "Pages in your copy",
    "pagesLine": "Story from page {{start}} to {{end}}",
    "changePages": "Change pages",
    "savePages": "Save pages",
    "remove": "Remove from shelf",
    "removeQuestion": "Remove this book and its history from your shelf?",
    "removeConfirm": "Yes, remove",
    "started": "Started {{date}}",
    "finishedOn": "Finished {{date}}",
    "errors": {
      "already_reading": "You are already reading this book.",
      "not_reading": "This book is not in progress. Read it again first.",
      "page_out_of_range": "That page is past the end of the story in your copy.",
      "different_book": "That edition is a different book.",
      "invalid_range": "The last page must come after the first."
    },
    "onPage": "I'm on page",
    "ofPages": "of {{end}}",
    "atPercent": "I'm",
    "percentSign": "% of the way through",
    "usePercent": "My e-reader shows a percentage",
    "usePage": "Use page numbers instead",
    "record": "Your record of this book",
    "thisBook": "This book",
    "showAllHistory": "Show all {{count}}",
    "closedFinished": "You finished this book. Pick it up again any time.",
    "closedStopped": "You stopped reading this book. Your place is kept if you come back to it.",
    "openYours": "You're reading this book. Open your copy",
    "switcher": "Your books",
    "update": {
      "button": "Update page",
      "title": "Where are you?",
      "titleIn": "Where are you in {{title}}?",
      "page": "Page",
      "percent": "% of the way",
      "stepLabel": "Add {{count}} pages",
      "endTitle": "The last page!",
      "endBody": "That's the end of the book. Mark it as finished?",
      "markFinished": "Yes, I finished it",
      "notYet": "Not yet",
      "justStarted": "I’m just starting",
      "toastPages_one": "+1 page",
      "toastPages_other": "+{{count}} pages",
      "toastSaved": "Saved",
      "toastWaiting": "Saved on this device. It will sync when you’re online."
    },
    "menu": {
      "label": "More for this book",
      "otherEdition": "Switch to another edition"
    },
    "empty": {
      "title": "What are you reading?",
      "body": "Find your book and keep your place in it. Notes and clubs build on that.",
      "find": "Find the book",
      "invite": "Got an invite? Join a club"
    },
    "notesFor": "Whose notes",
    "notesClub": "Club",
    "notesEveryone": "Everyone",
    "club": {
      "next": "Next: {{when}}",
      "readTo": "read to p. {{page}}"
    }
  },
  "notes": {
    "title": "Notes",
    "clubTitle": "Club notes",
    "publicTitle": "Readers’ notes",
    "write": "Write a note",
    "bodyLabel": "Your note",
    "bodyPlaceholder": "A thought, a quote, a question…",
    "atPage": "At page",
    "atPercent": "At percent",
    "usePercent": "Use a percentage instead",
    "usePage": "Use a page number instead",
    "audienceLabel": "Who can see it",
    "audience_private": "Only me",
    "audience_club": "Club",
    "audience_public": "Everyone",
    "audienceHint_private": "Only you can see this note.",
    "audienceHint_club": "Members of {{club}} see it with your name. Anyone who hasn’t reached this point sees it blurred.",
    "audienceHint_public": "Anyone reading this book sees it with your name. Anyone who hasn’t reached this point sees it blurred.",
    "add": "Add note",
    "added": "Note added.",
    "startToWrite": "Start reading this book to write notes. Notes ahead of where you are stay blurred until you tap them.",
    "startToWriteClub": "Start reading the club’s book to write notes for the club.",
    "scopeLabel": "Show notes",
    "scopeAll": "All",
    "scopePublic": "Everyone’s",
    "scopeMine": "Mine",
    "empty": "No notes on this book yet.",
    "emptyPublic": "No one has shared a note on this book yet.",
    "emptyMine": "You haven’t written any notes on this book.",
    "notReadingHint": "You aren’t reading this book, so every note is blurred. Tap one to read it.",
    "youAreHere": "You are here · p. {{page}}",
    "place": "p. {{page}}",
    "placeApprox": "≈ p. {{page}}",
    "placePercent": "{{percent}}%",
    "you": "You",
    "edited": "edited",
    "deleted": "This note was deleted.",
    "justNow": "just now",
    "minutesAgo": "{{count}} min ago",
    "hoursAgo": "{{count}} h ago",
    "daysAgo": "{{count}} d ago",
    "spoilerAhead": "Ahead of where you are.",
    "spoilerUnknown": "May give away the story.",
    "revealLabel": "Note at {{place}}. {{hint}} Show it.",
    "react": "React",
    "reactionMine": "{{emoji}} {{count}}, including you. Tap to take yours back.",
    "reactionOthers": "{{emoji}} {{count}}. Tap to add yours.",
    "reply": "Reply",
    "replyLabel": "Your reply",
    "sendReply": "Reply",
    "more": "More",
    "moreLabel": "More actions for the note by {{name}}",
    "moreLabelMine": "More actions for your note",
    "edit": "Edit",
    "editLabel": "Edit your note",
    "delete": "Delete",
    "deleteQuestion": "Delete this note? Replies to it stay, under a “deleted” placeholder.",
    "deleteConfirm": "Yes, delete",
    "moderate": "Remove from club",
    "moderateQuestion": "Remove this note for everyone in the club?",
    "moderateConfirm": "Yes, remove",
    "report": "Report",
    "reportQuestion": "What’s wrong with it? It will be hidden for you right away.",
    "reason_spoiler": "Spoils the story",
    "reason_offensive": "Offensive",
    "reason_spam": "Spam",
    "reason_other": "Something else",
    "reported": "Thanks. The note is hidden for you, and enough reports hide it for everyone.",
    "block": "Block {{name}}",
    "blockQuestion": "Block {{name}}? Neither of you will see the other’s notes or replies. You can unblock them from your account.",
    "blockConfirm": "Yes, block",
    "blocked": "{{name}} is blocked.",
    "errors": {
      "not_found": "That note is gone, or you can’t see it any more.",
      "club_not_reading_this": "That club is reading a different book now.",
      "unknown_reading": "That reading is no longer on your shelf.",
      "reply_to_reply": "Reply to the original note instead.",
      "note_deleted": "That note was deleted, so it can’t take new replies.",
      "forbidden": "Only the author can do that.",
      "own_note": "You can’t report your own note.",
      "self": "You can’t block yourself.",
      "rate_limited": "That’s a lot of notes in a short time. Wait a few minutes and try again."
    },
    "showNote": "Show note",
    "timeline": {
      "title": "Notes along the book",
      "hint": "Each mark is a note, left at that place in the book. Marks past your ribbon stay blurred until you choose to read them.",
      "empty": "No club notes yet. They appear here at the page they were written on.",
      "count_one": "{{count}} note",
      "count_other": "{{count}} notes",
      "at": "At {{place}}",
      "close": "Close",
      "markLabel": "{{notes}} at {{place}} by {{names}}",
      "markAhead": ", ahead of where you are",
      "previewAhead": "Ahead of where you are · {{place}}",
      "you": "you"
    },
    "sheet": {
      "title": "Note at p. {{page}}",
      "changePage": "Change page",
      "post": "Post",
      "fab": "Note"
    },
    "line": {
      "label": "Notes along the book",
      "you": "you",
      "at": "{{percent}}% through",
      "markLabel": "{{notes}} at {{place}} by {{names}}",
      "sheetTitle": "Notes at {{place}}",
      "person": "{{name}}, {{percent}}% through",
      "notStarted": "{{name}} hasn’t started",
      "percent": "{{name}} {{percent}}%",
      "withYou": "{{name}} is with you",
      "ahead_one": "{{name}} ≈1 page ahead",
      "ahead_other": "{{name}} ≈{{count}} pages ahead",
      "behind_one": "{{name}} ≈1 page behind",
      "behind_other": "{{name}} ≈{{count}} behind",
      "more": "+{{count}} more"
    },
    "feed": {
      "empty": "No notes yet. Tap + Note to leave the first one."
    }
  },
  "admin": {
    "title": "Reported notes",
    "intro": "Notes and replies readers reported, most reported first. A public note with 3 reports is hidden from everyone but its author until you decide. Keeping a note shows it again, except to the people who reported it.",
    "empty": "Nothing to review.",
    "notAllowed": "This page is for moderators.",
    "reply": "reply",
    "hidden": "Hidden from readers until you decide.",
    "reports_one": "{{count}} report",
    "reports_other": "{{count}} reports",
    "keep": "Keep it",
    "remove": "Remove",
    "removeQuestion": "Remove this note for everyone? Its author is not told.",
    "removeConfirm": "Yes, remove",
    "sectionTitle": "Moderation",
    "sectionBody": "You review notes that readers report.",
    "open": "Review reported notes"
  },
  "legal": {
    "updated": "Last updated {{date}}",
    "privacy": "Privacy",
    "terms": "Terms",
    "help": "Help and contact",
    "linksLabel": "About Bookclub"
  },
  "crash": {
    "title": "Something went wrong",
    "body": "This page broke. We've been told about it. Try again, or start over from the beginning.",
    "retry": "Try again",
    "home": "Go to the start"
  },
  "tabs": {
    "home": "Home",
    "books": "My books",
    "clubs": "Clubs",
    "you": "You",
    "label": "Main"
  },
  "you": {
    "account": "Account",
    "accountDetail": "Name, sign-in, devices, your data",
    "appearance": "Appearance"
  },
  "myBooks": {
    "title": "My books",
    "want": "Want to read",
    "updateLabel": "Update page: {{title}}",
    "find": "Find a book",
    "start": "Start reading",
    "startLabel": "Start reading: {{title}}",
    "finished": "Finished {{date}}",
    "didntFinish": "Didn’t finish",
    "stoppedAt": "Stopped at p. {{page}}",
    "stoppedEarly": "Stopped before page 1",
    "addShort": "Add",
    "readingNow": "Reading now",
    "readInYear": "Read in {{year}}",
    "readUndated": "Read",
    "atPage": "p. {{page}} · {{percent}}%",
    "atPercent": "{{percent}}%",
    "readingEmpty": "Nothing on the go right now.",
    "wantEmpty": "Save a book you’d like to read and it stands here.",
    "readEmpty": "Books you finish stand here.",
    "showAll": "Show all {{count}}",
    "showLess": "Show less"
  },
  "finished": {
    "title": "You finished {{title}}",
    "notesOpen_one": "The note from another reader is open now.",
    "notesOpen_other": "All {{count}} notes from other readers are open now.",
    "allOpen": "Every note on this book is open to you now.",
    "lastThought": "Leave a last thought",
    "readNotes": "Read the notes",
    "nextUp": "Next up",
    "undo": "Not finished yet? Undo",
    "countThisYear_ordinal_one": "That’s your {{count}}st book this year.",
    "countThisYear_ordinal_two": "That’s your {{count}}nd book this year.",
    "countThisYear_ordinal_few": "That’s your {{count}}rd book this year.",
    "countThisYear_ordinal_other": "That’s your {{count}}th book this year."
  },
  "homeFeed": {
    "greeting": {
      "morning": "Good morning, {{name}}",
      "afternoon": "Good afternoon, {{name}}",
      "evening": "Good evening, {{name}}"
    },
    "readingNow": "Reading now",
    "seeAll": "See all",
    "update": "Update",
    "comingUp": "Coming up",
    "inYourClubs": "In your clubs",
    "quiet": "All quiet in your clubs these last two weeks.",
    "together": "Reading is better together",
    "togetherBody": "Start a club for friends or family, or join one with a code.",
    "progress_one": "{{name}} read 1 page",
    "progress_other": "{{name}} read {{count}} pages",
    "progressDetail": "{{percent}}% through {{title}}",
    "note": "{{name}} left a note at {{place}}",
    "reply": "{{name}} replied to your note",
    "noteAhead": "Ahead of where you are",
    "finished": "{{name}} finished {{title}}",
    "joined": "{{name}} joined {{club}}",
    "weekLine_one": "1 page in the last 7 days",
    "weekLine_other": "{{pages}} pages in the last 7 days"
  },
  "stats": {
    "weekPages_one": "page in the last 7 days",
    "weekPages_other": "pages in the last 7 days",
    "yearBooks_one": "book finished in {{year}}",
    "yearBooks_other": "books finished in {{year}}",
    "yearPages_one": "page read in {{year}}",
    "yearPages_other": "pages read in {{year}}",
    "calendarTitle": "Days you read",
    "day_zero": "{{day}} · no reading",
    "day_one": "{{day}} · 1 page",
    "day_other": "{{day}} · {{count}} pages",
    "daysRead_zero": "No reading logged in the last {{weeks}} weeks",
    "daysRead_one": "Read on 1 day in the last {{weeks}} weeks",
    "daysRead_other": "Read on {{count}} days in the last {{weeks}} weeks",
    "less": "Less",
    "more": "More",
    "showDays": "Show the days",
    "hideDays": "Hide the days",
    "pages_one": "1 page",
    "pages_other": "{{count}} pages",
    "shelfTitle": "Finished in {{year}}",
    "title": "Your reading"
  },
  "popular": {
    "title": "Popular this week",
    "orStart": "Or start with one of these"
  },
  "sync": {
    "waiting_one": "1 update saved here, waiting to sync",
    "waiting_other": "{{count}} updates saved here, waiting to sync",
    "syncing": "Syncing…",
    "now": "Sync now",
    "whatPage": "Page {{page}}",
    "whatPercent": "{{percent}}%",
    "yourBook": "your book",
    "refused": "{{what}} in {{title}} wasn’t saved. {{reason}}",
    "dismiss": "OK"
  },
  "scan": {
    "title": "Scan a book",
    "point": "Point at the barcode on the back of the book",
    "notABook": "That isn’t a book’s barcode. Look for the one starting 978 or 979.",
    "looking": "Looking up ISBN {{isbn}}…",
    "notFound": "We couldn’t find ISBN {{isbn}} in the catalogues. You can add the book by hand.",
    "again": "Scan again",
    "torch": "Torch",
    "ask": "Point your camera at the barcode on the back of a book and we’ll find it. The camera is only on while this screen is open.",
    "denied": "Camera access is off for this app. Turn it on in Settings to scan barcodes, or type the ISBN instead.",
    "allow": "Allow the camera",
    "openSettings": "Open Settings",
    "typeInstead": "Type it instead"
  },
  "pace": {
    "ahead_one": "1 page ahead of the rabbit",
    "ahead_other": "{{count}} pages ahead of the rabbit",
    "behind_one": "1 page behind the rabbit",
    "behind_other": "{{count}} pages behind the rabbit",
    "level": "Right with the rabbit",
    "rabbitAt": "The rabbit is on p. {{page}} today",
    "toPage_one": "1 page a day to reach p. {{page}} by {{day}}",
    "toPage_other": "{{count}} pages a day to reach p. {{page}} by {{day}}",
    "toPageToday_one": "1 page today to reach p. {{page}}",
    "toPageToday_other": "{{count}} pages today to reach p. {{page}}",
    "toEnd_one": "1 page a day to finish by {{day}}",
    "toEnd_other": "{{count}} pages a day to finish by {{day}}",
    "toEndToday_one": "1 page today to finish",
    "toEndToday_other": "{{count}} pages today to finish",
    "readyMeeting": "Ready for {{day}}: you’re past p. {{page}}",
    "readyEnd": "On track to finish by {{day}}"
  },
  "today": {
    "streak_one": "1-week streak",
    "streak_other": "{{count}}-week streak",
    "streakStart": "Read on {{days}} days this week to start a streak",
    "weekDays": "{{done}} of {{need}} reading days this week",
    "weekDone_one": "This week counts: {{count}} reading day",
    "weekDone_other": "This week counts: {{count}} reading days",
    "weekLabel": "Days you read this week: {{days}}",
    "noDays": "none yet",
    "pagesToday_one": "1 page today",
    "pagesToday_other": "{{count}} pages today",
    "goalProgress": "{{done}} of {{goal}} pages today",
    "goalDone": "{{done}} of {{goal}} pages today · goal met",
    "setDailyGoal": "Set a daily goal"
  },
  "goals": {
    "title": "Goals",
    "edit": "Edit",
    "set": "Set goals",
    "sheetTitle": "Your goals",
    "sheetBody": "Both are optional. Leave one empty for no goal.",
    "yearly": "Books to finish in {{year}}",
    "daily": "Pages a day",
    "none": "No goal",
    "invalid": "A whole number from 1 to {{max}}, or empty.",
    "save": "Save goals",
    "saved": "Goals saved",
    "yearProgress": "{{done}} of {{goal}} books in {{year}}",
    "yearCount_one": "1 book finished in {{year}}",
    "yearCount_other": "{{count}} books finished in {{year}}"
  },
  "finishBy": {
    "menu": "Finish by a date…",
    "menuSet": "Finish by {{date}} (change)",
    "title": "Finish by",
    "body": "Pick a day to finish this book. You’ll see how many pages a day that takes, and a rabbit to race.",
    "week": "In a week",
    "twoWeeks": "In two weeks",
    "month": "In a month",
    "monthEnd": "End of the month",
    "date": "Or pick a date",
    "save": "Save the date",
    "remove": "Remove the date",
    "invalid": "Pick a day from today on."
  },
  "appearance": {
    "title": "Appearance",
    "style": "Style",
    "mode": "Light or dark",
    "system": "Automatic",
    "light": "Light",
    "dark": "Dark",
    "onDevice": "Follows you to every device you sign in on.",
    "styles": {
      "classic": {
        "name": "Classic",
        "body": "Paper and ink, with a serif to read in."
      },
      "sleek": {
        "name": "Sleek",
        "body": "Clean and crisp, in cool tones."
      },
      "playful": {
        "name": "Playful",
        "body": "Soft colours, round and friendly."
      }
    },
    "sample": {
      "title": "The Hobbit",
      "where": "Page 188 of 320 · 59%",
      "update": "Update page",
      "note": "+ Note"
    }
  },
  "notifications": {
    "title": "Notifications",
    "openWithUnread_one": "Notifications, {{count}} new",
    "openWithUnread_other": "Notifications, {{count}} new",
    "new": "New",
    "settings": "Notification settings",
    "rowDetail": "Replies, meetings, club news",
    "empty": "Nothing yet. Replies to your notes, tomorrow's meeting and news from your clubs show up here.",
    "loadFailed": "Couldn't load your notifications. Pull down to try again.",
    "saveFailed": "Couldn't save that. Check your connection and try again.",
    "followsYou": "These follow you to every device you sign in on.",
    "readTo": "read up to p. {{page}}",
    "kinds": {
      "reply": "{{name}} replied to your note",
      "replyPage": "{{name}} replied to your note on p. {{page}}",
      "notes_one": "{{name}} left a note on a page you've read",
      "notes_other": "{{count}} new notes on pages you've read, the latest from {{name}}",
      "meetingSoon": "{{club}} meets {{when}}",
      "meetingSet": "New meeting: {{when}}",
      "meetingMoved": "Meeting moved to {{when}}",
      "finished": "{{name}} finished {{book}}",
      "bookChosen": "{{name}} chose the next book: {{book}}",
      "joined": "{{name}} joined"
    },
    "push": {
      "title": "Get these on your phone",
      "body": "Replies, tomorrow's meeting and club news, as notifications. Never a word from past where you are.",
      "denied": "Notifications are off for Bookclub. You can turn them on in your phone's Settings.",
      "turnOn": "Turn on notifications",
      "openSettings": "Open Settings",
      "notNow": "Not now",
      "on": "Notifications are on for this phone."
    },
    "topics": {
      "replies": {
        "name": "Replies to you",
        "body": "Someone replied to your note."
      },
      "meetings": {
        "name": "Meeting reminders",
        "body": "The day before, with the page to reach in your copy."
      },
      "notes": {
        "name": "Notes from your clubs",
        "body": "Clubmates' notes on pages you've read, a few at a time."
      },
      "club": {
        "name": "Club news",
        "body": "A new book, a meeting set or moved, someone finishing or joining."
      }
    }
  },
  "shelf": {
    "customize": "Your shelf",
    "books": "Books",
    "covers": "Covers",
    "spines": "Spines",
    "spinesHint": "Reading now keeps its covers, with your place under each.",
    "finish": "Finish",
    "finishes": {
      "oak": "Oak",
      "walnut": "Walnut",
      "birch": "Birch",
      "white": "White",
      "graphite": "Graphite",
      "rose": "Rose"
    },
    "followsYou": "Follows you to every device you sign in on."
  }
}
